/* ════════════════════════════════════════════════════════════════
   Tessera Diamonds — Diamonds feed: sticky "Design Your Ring" bar.
   Slides up once the visitor scrolls past the hero; dismissible for the
   session. (This page uses native scroll, so window scroll events fire.)
   ════════════════════════════════════════════════════════════════ */
(function () {
  const bar = document.getElementById('rbBar');
  if (!bar) return;
  if (sessionStorage.getItem('td-rbbar-dismissed') === '1') return;

  bar.hidden = false; // off-screen via CSS transform until .is-visible

  const threshold = Math.round(window.innerHeight * 0.7);
  let ticking = false;
  function update() {
    bar.classList.toggle('is-visible', window.scrollY > threshold);
    ticking = false;
  }
  window.addEventListener('scroll', () => {
    if (!ticking) { ticking = true; requestAnimationFrame(update); }
  }, { passive: true });
  update();

  const close = document.getElementById('rbBarClose');
  if (close) close.addEventListener('click', () => {
    bar.classList.remove('is-visible');
    try { sessionStorage.setItem('td-rbbar-dismissed', '1'); } catch (e) {}
  });
})();
